import  { useEffect, useState, useMemo } from "react";

import "./page.css";
import axios from "../utils/axiosInstance";

import FeaturedCategories from "../components/category/FeaturedCategories";
import ProductList from "../components/product/ProductList";
import { useNavigate } from "react-router-dom";
import Toolbar from "../containers/Header/Toolbar/Toolbar";
import FilterSidebar from "../components/filter/FilterSidebar";
import SelectBox from "../components/edittext/selectbox/SelectBox";
import Footer from "../containers/Footer/Footer";
import useDynamicTabTitle from "../useDynamicTabTitle";
const CategoryPage = ({
  categoryName,
  products,
  categoryId,
  categories,
  brand,
}) => {
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const [finalproduct, setProduct] = useState(products || []);
  const [sort, setSort] = useState();
  const navigate = useNavigate();
  // console.log("categoryname",categoryName)
  useDynamicTabTitle(categoryName ? `Buy ${categoryName} Products?` : "Loading...");
  const sortArr = [
    "Most Expensive",
    "Most Cheap",
    "Most Relevant",
    "Newest",
    "Most Sell",
    "Most popular",
  ];
  const handleSelectCategory = (cat) => {
    navigate(`/category/${cat._id}`);
  };
  const applyFilters = async (
    categoryId,
    selectedBrand,
    minPrice,
    maxPrice,
    selectedAttributes
  ) => {
    try {
      const res = await axios.get("/products", {
        params: {
          category: categoryId,
          brand: selectedBrand,
          minPrice,
          maxPrice,
          attributes: JSON.stringify(selectedAttributes), // 🔹 تبدیل به استرینگ
        },
      });
      // console.log("Filtered Products:", res.data.products);
      setProduct(res.data.products);
    } catch (err) {
      console.error("Filter error:", err);
    }
  };
  useEffect(() => {
    if (products) {
      setProduct(products);
    } else {
      // اگر محصول null بود (حالت افزودن)، مقادیر رو ریست کن
      setProduct([]);
    }
  }, [products]);
  useEffect(() => {
    if (!categoryId) return;

    axios
      .get(`/categories/${categoryId}/path`)
      .then((res) => {
        setBreadcrumbs(res.data); // انتظار داریم که آرایه‌ای از دسته‌های پدر تا دسته فعلی باشه
        setProduct(products);
      })
      .catch((err) => {
        console.error("خطا در دریافت breadcrumb:", err);
      });
  }, [categoryId]);
  const sortedProducts = useMemo(() => {
    if (!finalproduct) return [];

    let sorted = [...finalproduct];

    switch (sort) {
      case "Most Expensive":
        sorted.sort((a, b) => b.price - a.price);
        break;
      case "Most Cheap":
        sorted.sort((a, b) => a.price - b.price);
        break;
      case "Newest":
        sorted.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        break;
      case "Most Sell":
        sorted.sort((a, b) => b.salesCount - a.salesCount);
        break;
      case "Most popular":
        sorted.sort((a, b) => b.rating - a.rating);
        break;
      default: // Most Relevant
        // اینجا می‌تونی لاجیک مرتبط بودن رو بعداً تعریف کنی
        break;
    }
    return sorted;
  }, [sort, finalproduct]);

  return (
    <>
      <Toolbar />
      <div className="container-fluid px-3 py-3">
        {/* Breadcrumb */}
        <nav aria-label="breadcrumb" className="mb-3">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="/">Home</a>
            </li>
            {breadcrumbs.map((item, index) => (
              <li
                key={item._id}
                className={`breadcrumb-item ${
                  index === breadcrumbs.length - 1 ? "active" : ""
                }`}
                aria-current={
                  index === breadcrumbs.length - 1 ? "page" : undefined
                }
              >
                {index === breadcrumbs.length - 1 ? (
                  item.name
                ) : (
                  <a href={`/category/${item._id}`}>{item.name}</a>
                )}
              </li>
            ))}
          </ol>
        </nav>

        {/* عنوان دسته */}
        <h3 className="mb-4">{categoryName} Products</h3>

        {/* لیست محصولات به صورت کارت */}
        {categories.length > 0 && (
          <div className="d-flex mb-3 flex-column align-items-lg-center">
            <FeaturedCategories
              categories={categories}
              onSelect={handleSelectCategory}
            />
          </div>
        )}

        <div className="row ">
          {/* Sidebar دسکتاپ */}
          <div className="col-lg-3 d-none d-lg-block order-lg-0">
            <FilterSidebar
              brands={brand}
              categoryId={categoryId}
              applyFilters={applyFilters}
            />
          </div>
          <div className="col-12 col-lg-9 order-lg-1 pe-4">
            {/* دکمه + پنل کشویی برای موبایل */}

            <div class="container mt-4">
              <div class="d-flex justify-content-between align-items-start mb-3 ">
                  <ul className="list-inline d-none d-lg-flex mb-0">
                  {sortArr.map((item, index) => (
                    <li key={index} className="list-inline-item">
                      <button
                        onClick={() => setSort(item)}
                        className={`btn btn-sm rounded-pill mx-1 ${
                          sort === item
                            ? "btn-primary text-white"
                            : "btn-outline-secondary"
                        }`}
                      >
                        {item}
                      </button>
                    </li>
                  ))}
                </ul>
                <div className="ms-2 d-lg-none mb-0 ">
                  <FilterSidebar
                    brands={brand}
                    categoryId={categoryId}
                    applyFilters={applyFilters}
                  />
                </div>
                <div className="col-6 col-md-3 ps-5">
                  <SelectBox
                    value={sort}
                    onChange={setSort}
                    array={sortArr}
                    text="Sort"
                    bcolor="primary"
                    textcolor="dark"
                    bgcolor="white"
                    padding="0"
                    margin="0"
                    className="d-lg-none"
                  />
                </div>
              
              </div>
              <hr className="mb-3" />
            </div>
            <ProductList products={sortedProducts} />
          </div>

          {/* محصولات */}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default CategoryPage;
// {products.map((product) => (
//           <div
//             key={product._id}
//             className="card p-2"
//             style={{ width: "18rem", flex: "1 0 18rem" }}
//           >
//             <Link
//               to={`/product/${product._id}`}
//               style={{ textDecoration: "none", color: "inherit" }}
//             >
//               <img
//                 src={`${process.env.REACT_APP_API_BASE_URL}${product.images?.[0]}`}
//                 className="card-img-top"
//                 alt={product.title}
//                 style={{ height: "180px", objectFit: "contain" }}
//               />
//               <div className="card-body d-flex flex-column">
//                 <h6 className="card-title">{product.title}</h6>
//                 <p className="mb-1 text-success fw-bold">
//                   {product.price.toLocaleString()} تومان
//                 </p>
//                 {product.discount > 0 && (
//                   <p className="text-danger small">-{product.discount}%</p>
//                 )}
//               </div>
//             </Link>
//             <button className="btn btn-primary mt-2">افزودن به سبد</button>
//           </div>
//         ))}
